import { render, staticRenderFns } from "./ProcessApproval.vue?vue&type=template&id=fd5bce6e&scoped=true&"
import script from "./ProcessApproval.vue?vue&type=script&lang=js&"
export * from "./ProcessApproval.vue?vue&type=script&lang=js&"
import style0 from "./ProcessApproval.vue?vue&type=style&index=0&id=fd5bce6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5bce6e",
  null
  
)

component.options.__file = "ProcessApproval.vue"
export default component.exports